module.exports = __webpack_public_path__ + "img/75597.99391f10.svg";